document.addEventListener('DOMContentLoaded', function () {
  const wrappers = Array.from(document.querySelectorAll('.product-card__media-wrapper'));

  wrappers.forEach((wrapper) => {
    const slider = wrapper.querySelector('[data-product-slider]');
    const slides = slider?.querySelectorAll('.product-card__slide');
    const dots = wrapper.querySelectorAll('.product-slider-dot');
    const productUrl = wrapper.querySelector('a.product-card__media-link')?.getAttribute('href');

    if (!slider || slides.length <= 1) return;

    let currentIndex = 0;

    const setIndex = (i) => { currentIndex = i; };
    const getIndex = () => currentIndex;

    const updateSlider = () => {
      slider.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, i) => dot.classList.toggle('active', i === currentIndex));
    };

    updateSlider();

    // Dot navigation
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        setIndex(i);
        updateSlider();
      });
    });

    // Swipe (mobile)
    let isSwiping = false;
    let startX = 0;

    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isSwiping = false;
    });

    slider.addEventListener('touchmove', (e) => {
      const delta = Math.abs(e.touches[0].clientX - startX);
      if (delta > 10) isSwiping = true;
    });

    slider.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < slides.length - 1) setIndex(currentIndex + 1);
        else if (diff < 0 && currentIndex > 0) setIndex(currentIndex - 1);
        updateSlider();
      }
    });

    // Desktop drag support
    let isDragging = false;
    let dragStartX = 0;
    let dragEndX = 0;

    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      dragStartX = e.clientX;
    });

    document.addEventListener('mouseup', (e) => {
      if (!isDragging) return;

      dragEndX = e.clientX;
      const dragDistance = dragEndX - dragStartX;

      if (Math.abs(dragDistance) > 50) {
        if (dragDistance < 0 && currentIndex < slides.length - 1) {
          setIndex(currentIndex + 1);
        } else if (dragDistance > 0 && currentIndex > 0) {
          setIndex(currentIndex - 1);
        }
        updateSlider();
      }

      isDragging = false;
    });

    slider.addEventListener('mouseleave', () => {
      isDragging = false;
    });

    // Prevent accidental click when dragging/swiping
    let mouseStartX = 0;
    let hasDragged = false;

    slider.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      hasDragged = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (Math.abs(e.clientX - mouseStartX) > 5) {
        hasDragged = true;
      }
    });

    wrapper.querySelectorAll('.product-card__slide').forEach((slide) => {
      slide.addEventListener('click', (e) => {
        if (hasDragged || isSwiping || e.target.closest('.product-slider-dot')) return;
        if (productUrl) window.location.href = productUrl;
      });
    });
  });
});